module.exports = __webpack_public_path__ + "img/neotag_unit_pink-02.1b8d8da5.svg";